import i18n from 'src/i18n';

const configTable = () => ({
  tableColumns: [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 120,
      sortable: true,
    },
    {
      prop: 'user',
      label: i18n.t('common_words.user'),
      minWidth: 140,
      sortable: true,
      formatter: (row) => {
        const fullName = `${row.user.first_name || ''} ${row.user.last_name || ''}`.trim();
        return fullName || '-';
      },
    },
    {
      prop: 'workers',
      label: i18n.t('labor.workers'),
      minWidth: 250,
      show: false,
      crewWorkers: true,
    },
  ],
});

export default configTable;
